import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {StatesService} from '../state/states.service';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  colorSamples = {
    for_level: ['#C4E1E2', '#0476D0', '#EE5AB1', '#5429DA', '#5C5350', '#BCBEC0'],
    for_other_levels: ['rgba(196, 225, 226, 0.5)', 'rgba(4, 118, 208, 0.5)', 'rgba(238, 90, 177, 0.5)', 'rgba(84, 41, 218, 0.5)',
      'rgba(92, 83, 80, 0.5)', 'rgba(188, 190, 192, 0.5)']
  };

  constructor(
    private http: HttpClient,
    private stateService: StatesService,
    private translateService: TranslateService) {
  }

  getDashboardEdasForCurrentLevel() {
    return this.http.get(`edas-dashboard/level/` + this.stateService.stateLevel.toString());
  }

  getDashboard(timeRange: string) {
    const params = {
      level: this.stateService.stateLevel.toString(),
      time_range: timeRange
    };
    return this.http.get(`dashboard`, {params});
  }

  getFormattedTimeRange(timeRange: string, number: boolean = true) {
    const timeRangeFragments = timeRange.split('_');
    return number ?
      timeRangeFragments[0] + ' ' + this.translateService.instant(timeRangeFragments[1].toUpperCase())
      : this.translateService.instant(timeRangeFragments[1].toUpperCase());
  }

  getFormattedOsmosAppsNames(appName: string, levelName?): string {
    switch (appName) {
      case 'api':
        return 'API';
      case 'store':
        return 'Opm';
      case 'total_for_level':
        return this.translateService.instant('TOTAL') + ' ' + levelName;
      default:
        const translation = this.translateService.instant(appName);
        if (appName === translation) {
          return appName.charAt(0).toUpperCase() + appName.slice(1);
        } else {
          return translation;
        }
    }
  }
}
